

export const getChannels = (state) => state.channels.channels;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/Channels.selectors.js